<template>
	<div>
		<div class="row mb-2">
			<div class="col-md-6">
				<h1>{{ candidate.studentid }} {{ candidate.displayName }}</h1>
				<h2>{{ osce.osce_title }} | {{ oscestation.oscestation_code }}: {{ oscestation.oscestation_title }}</h2>
				<h2>{{ $t("examiner") }}: {{ formresponse.usersignoff_displayname }}</h2>
			</div>
			<div class="col-md-6">
				<div class="float-right">
					<template v-if="marking">
						<!--<button v-if="!paused" class="btn btn-danger" @click="pauseOSCEButton()">{{$t('pause')}}</button>-->
						<button v-if="paused" class="btn btn-primary" @click="resumeOSCEButton()">{{$t('resume')}}</button>
						<button class="btn btn-warning ml-2" @click="withdrawButton()">{{$t('withdraw')}}</button>
						<button class="btn btn-danger ml-2" @click="abortButton()"><b-icon icon="exclamation-circle"></b-icon> {{$t('abort')}}</button>
						<button v-if="(!paused && completionStats.percentage == 100)" class="btn btn-success ml-2" @click="completedButton()">{{$t('completed')}}</button>
					</template>
					<template v-if="canreopen">
						<!--<button v-if="!paused" class="btn btn-danger" @click="pauseOSCEButton()">Pause</button>-->
						<button class="btn btn-warning ml-2" @click="reopenOSCEButton()">{{$t('reopen')}}</button>
					</template>
				</div>
			</div>
		</div>
		
		<div class="row">

			<div class="col-12 col-lg-9 order-lg-1">

				<div class="card mb-8">
					<div class="card-body">
						<div class="row">
							<div class="col-12 col-lg-6">
								<div class="header-stats">
									<div class="stat">
										<span class="stat-label">{{ $t('progess') }}</span>
										<span class="stat-value">{{ completionStats.percentage }}%</span>
									</div>
									<div class="stat">
										<span class="stat-label">{{ $t('graded') }}</span>
										<span class="stat-value">{{ completionStats.graded }}/{{ completionStats.total }}</span>
									</div>
									<!--
									<div class="stat">
										<span class="stat-label">Score</span>
										<span class="stat-value">{{ completionStats.totalScore }}/{{ completionStats.maxPossibleScore }}</span>
									</div>
									-->
								</div>
							</div>
							<div class="col-12 col-lg-6" style="text-align: right">
								<div class="btn-group mt-2">
									<button :class="!showOnlyEmpty ? 'btn btn-primary' : 'btn btn-secondary'" @click="showOnlyEmpty = false">{{ $t('all') }}</button>
									<button :class="showOnlyEmpty ? 'btn btn-primary' : 'btn btn-secondary'" @click="showOnlyEmpty = true">{{ $t('unanswered') }}</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			
				<template v-for="(page, pageIndex) in filteredPages">
					<FormGrid
						:key="pageIndex"
						:page="page"
						:formresponse="formresponse"
						:readonly="(!marking || paused)"
						:viewAs="role"
						:showOnlyEmpty="showOnlyEmpty"
						:pageStats="getPageStats(page)"
					></FormGrid>
				</template>

				<div class="text-right mb-4" v-if="marking && !paused && completionStats.percentage == 100">
					<button class="btn btn-success" @click="completedButton()">{{$t('completed')}}</button>
				</div>
			</div>

			<div class="col-12 col-lg-3 order-lg-1 osce-sidebar">
				<b-nav pills class="mb-2">
    				<b-nav-item
    					:active="sidebartab=='questions'"
    					@click="sidebartab='questions'"
    				>{{ $t('questions') }}</b-nav-item>
    				<b-nav-item
    					:active="sidebartab=='messages'"
    					@click="sidebartab='messages'"
    				>{{ $t('messages') }}
    					<span class="badge badge-pill badge-danger" v-if="notificationCount">
    						{{notificationCount}}
    					</span>
    				</b-nav-item>
   				 	<b-nav-item
    					:active="sidebartab=='log'"
    					@click="sidebartab='log'"
   				 	>{{ $t('log') }}</b-nav-item>
   				 </b-nav>
				<div class="card mb-8 osce-sidebar-panel" v-show="sidebartab=='questions'">
					<div class="card-body">
						<h2 class="card-title">{{ $t('questions') }}</h2>
						<ul class="list-unstyled question-nav-list mb-0">
							<li v-for="q in firstPageQuestions" :key="q.id">
								<a href="#" @click.prevent="scrollToQuestion(q.id)">
									<b-icon
										:icon="q.answered ? 'check-circle-fill' : 'circle'"
										:variant="q.answered ? 'success' : 'secondary'"
										class="mr-1"
									></b-icon>
									{{ q.question }}
								</a>
							</li>
						</ul>
					</div>
				</div>
				<div class="card mb-8 osce-sidebar-panel" v-show="sidebartab=='messages'">
					<OSCEChat
						@new-message="handleNewMessage"
						:canCleanUpNotifications="sidebartab=='messages'"
					/>
				</div>
				<div class="card mb-8 osce-sidebar-panel" v-if="sidebartab=='log'">
					<div class="card-body">
						<h2 class="card-title">{{ $t('log') }}</h2>
						<div v-for="(item, i) in filteredHistory" :key="i">
							<b-icon icon="clock"></b-icon>
							{{$datetime.getLocaleTimeStringFromTimestamp(item.created, false, true)}}
							{{item.event}}
						</div>
					</div>
				</div>
			</div>
			
			
		</div>
	</div>
</template>

<script>

import FormGrid from "src/components/FormEditor/FormGrid";
import OSCEChat from "../../components/OSCE/OSCEChat.vue";

export default {
	components: {
        FormGrid ,
        OSCEChat
	},
    mounted() {
    	if (this.$route.params.formresponseid) {
            this.getFormResponse(this.$route.params.formresponseid);
        } else {
            this.unableToOpenFormResponse();
        }
  	},
  	watch: {
  		formresponse: {
			handler() {
				this.formUpdated()
			},
			deep: true
		},
		/*
		latestNotification: {
			handler() {
				this.notificationCount = this.$store.getters.notificationCount
			},
			deep: true,  // Add this if notification is an object
			immediate: false
		}
		*/
  	},
  	beforeDestroy() {
  	},
	computed: {
		/*
		latestNotification() {
			return this.$store.state.latestNotification;
		},
		*/
        isTeacher() {
            return this.$UserSession.hasPriv.call(this, "MARK_TREATMENTSESSIONS");
        },
        canEdit() {
            return /*this.isTeacher || */!this.isSignedOff;
        },
        role() {
            if (this.$UserSession.hasPriv.call(this,'EDIT_ALLFORMS')) {
                return 'editall'
            }
            if (this.$UserSession.getValue('id') == this.formresponse.user_id) {
                return 'submitter';
            }
            if (this.$UserSession.getValue('id') == this.formresponse.userreview_id) {
                return 'reviewer';
            }
            if (this.$UserSession.getValue('id') == this.formresponse.usersignofffrom_id) {
                return 'signer';
            }
            return null;
        },
        filteredHistory(){
        	var filteredHistoryArray = [];
        	var completed = false;
        	for (let item of this.history) {
        		switch(item.event) {
        			case 'STARTED':
        			case 'PAUSE':
        			case 'RESUME':
        				filteredHistoryArray.push(item);
    					break;
        			case 'COMPLETED':
        				if(!completed){
        					filteredHistoryArray.push(item);
        				}
        				completed = true;
    					break;
        			case 'UPDATE':
        				if(completed){
        					filteredHistoryArray.push(item);
        				}
        				break;
        		}
        	}
        	return filteredHistoryArray
        },
        filteredPages() {
            const pages = [];
            if (this.formresponse.formresponse_data) {
                for (let page of this.formresponse.formresponse_data.pages) {
                    if (!this.userCanViewPage(page)) continue;
                    if (this.showOnlyEmpty && !this.pageHasUnansweredFields(page)) continue;
                    pages.push(page);
                }
            }
            return pages;
        },
        firstPageQuestions() {
            const page = this.filteredPages && this.filteredPages[0];
            if (!page || !page.grid) return [];
            const questions = [];
            for (let row of page.grid) {
                for (let col of row) {
                    for (let field of (col.fields || [])) {
                        if (field.question) {
                            const answered = !(field.value === null || field.value === '' || field.value === undefined);
                            questions.push({ id: field.id, question: field.question, answered });
                        }
                    }
                }
            }
            return questions;
        },
		filters() {
			return [
				{ 
					key: 'all', 
					label: 'All Criteria',
					count: undefined
				},
				{ 
					key: 'ungraded', 
					label: 'Ungraded', 
					count: this.completionStats.remaining 
				},
				{ 
					key: 'flagged', 
					label: 'Flagged', 
					count: this.flaggedCount 
				}
			];
		}
	},
    data() {
        const today = new Date();
        const past = new Date(today);
        past.setDate(today.getDate() - 31);

        const future = new Date(today);
        future.setDate(today.getDate()+7);

        return {
        	showOnlyEmpty: false,
        	sidebartab: 'questions',
        	notificationCount: 0,
        	marking: false,
        	canreopen: false,
        	paused: false,
            formid: null,
            osce: {
            	osce_id: null,
            	osce_title: null,
            },
            oscestation: {
            	oscestation_id: null,
            	oscestation_code: null,
            	oscestation_title: null
            },
            formresponse: {
                id: null,
                workflowstage_id: null,
                learningoutcomes: [],
                user_id: null,
                userfrom_id: null,
                usersubject_id: null,
                userreview_id: null,
                usersignofffrom_id: null,
                externaluser_id: null,
                ttevent_id:null,
                datetime: null,
                workbooks: [],
                workflowstage: {},
                formresponse_data: null
            },
            history: [],
            candidate: {},
            examiner: {},
            osces:[],
            total_count: 0,
            loading: false,
            submitting: false,
            students:[],
            ready:false,
        
        	completionStats: {
        		percentage: 0 ,
				graded: 0 ,
				total: 0 ,
				totalScore: 0 ,
				maxPossibleScore: 0
			},
            currentFilter: 'all',
            
            debounceoff: false,
            debounceTimerId: undefined,
			debounceTime:  1000,
            
            // UI state
            connectionStatus: 'connected',
            timeRemaining: 600, // 10 minutes in seconds
            isSaving: false,
            showSaveNotification: false,
            
        }
    },
    methods: {
    
    	pageHasUnansweredFields(page) {
    		if (!page.grid) return false;
    		for (const row of page.grid) {
    			for (const col of row) {
    				const fields = Array.isArray(col.fields) ? col.fields : Object.values(col.fields || {});
    				for (const field of fields) {
    					if (field.value === null || field.value === '' || field.value === undefined) return true;
    				}
    			}
    		}
    		return false;
    	},
    	getPageStats(page) {
    		let total = 0, graded = 0;
    		if (!page.grid) return { total: 0, graded: 0, percentage: 0 };
    		for (const row of page.grid) {
    			for (const col of row) {
    				if (!col.fields) continue;
    				for (const fieldId in col.fields) {
    					const field = col.fields[fieldId];
    					if (!('conditional' in field) || !field.conditional) {
    						if (field.type === 'select' || field.type === 'text' || field.type === 'textarea' || field.type === 'date' || field.type === 'html' || field.type === 'grade' || field.type === 'mark') {
    							total++;
    							if (field.value !== null && field.value !== undefined && field.value !== '') graded++;
    						}
    					}
    				}
    			}
    		}
    		return { total, graded, percentage: total > 0 ? Math.round((graded / total) * 100) : 0 };
    	},

    	handleNewMessage(notificationCount){
    		this.notificationCount = notificationCount
    	},

    	scrollToQuestion(fieldId){
    		const elementId = 'question-' + fieldId;
    		const el = document.getElementById(elementId);
    		if (el) {
    			el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    			return;
    		}
    		if (this.showOnlyEmpty) {
    			this.showOnlyEmpty = false;
    			this.$nextTick(() => {
    				const retryEl = document.getElementById(elementId);
    				if (retryEl) retryEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    			});
    		}
    	},

		goBack(){
			if(this.marking && this.$UserSession.getValue('id') == this.formresponse.usersignofffrom_id){
				var self = this;
				this.$store.commit("openDialog", {
					cancelBtn: true,
					title: this.$t("pause-this-osce-question"),
					content: this.$t("the-osce-will-be-paused"),
					confirmCallBack: function () {
						self.pauseOSCE(function(){
							self.$router.go(-1);
						})
					},
				});
			} else {
				this.$router.go(-1);
			}
		},
		
		tryEnableMarking(){                        
			if (this.$UserSession.hasPriv.call(this,'EDIT_ALLFORMS') || (this.$UserSession.getValue('id') == this.formresponse.usersignofffrom_id)) {
				if(this.formresponse.formresponse_completed != 1){
					this.marking = true;
					this.canreopen = false;
					return
				} else {
					this.marking = false;
					this.canreopen = true;
					return
				}
			}
			this.canreopen = false;
			this.marking = false;
			return
		},
    
        unableToOpenFormResponse() {
            const self = this;
            this.$store.commit("openDialog", {
                title: this.$t('oops'),
                content: this.$t('unable-to-open-form'),
                confirmCallBack: function () {
                    self.$router.replace('/osce/examiner');
                }
            });
        },
        formSubmitFailed() {
            this.$store.commit("openDialog", {
                title: this.$t("oops"),
                content: this.$t("form-save-failed"),
                confirmCallBack: function () {
                }
            });

        },
        formSubmitSuccess() {
            const self = this;
            this.$store.commit("openDialog", {
                title: this.$t("saved"),
                content: this.$t("form-saved"),
                confirmCallBack: function () {
                    self.$router.replace(`/osce/examiner`);
                }
            });

        },
        getFormResponse(id) {
            this.$store.commit("showBlockingSpinner");
            this.$cfetch(`${this.$settings.APIBaseURL}/osce/forms/load/${id}`)
                .then(json => {
                    this.$store.commit("hideBlockingSpinner");
                    if (json.status.toLowerCase() === "success") {
                        // fix collapsed textareas after first page
                        /*for(const page of json.;.formresponse_data.pages) {
                            page.autosizetextareas = false;
                        }
                        json.formresponse.formresponse_data.pages[0].autosizetextareas = true;*/

						this.debounceoff = true
                        this.formresponse = json.formresponse
                        this.history = json.history
                        this.osce = json.osce
                        this.oscestation = json.oscestation
                        this.getCandidateInfo()
                        
						this.tryEnableMarking()

                        if (this.formresponse.formresponse_dateofresponse) {
                            // Fix the date for the UI
                            this.formresponse.datetime = this.$datetime.getDateTimeFieldValueFromTimestamp(
                                this.formresponse.formresponse_dateofresponse ,
                                true
                            );
                        } else {
                            this.formresponse.datetime = this.$datetime.getDateTimeLocalFieldNowValue();
                        }
                        /*
                        this.getSubjects();
                        this.getReviewers();
                        this.getSigners();
                        */
                    } else {
                        this.unableToOpenFormResponse();
                    }
                }).catch(error => {
                    this.$store.commit("hideBlockingSpinner");
                    this.unableToOpenFormResponse();
                    this.$log.error.call(this, error);
                });
        },
        saveFormResponse(silent = false) {
        
        	if(!silent){
            	this.$store.commit("showBlockingSpinner");
            }

            this.$cfetch(`${this.$settings.APIBaseURL}/osce/forms/save/`, {
                method: 'post',
                data: {
                    formresponse: this.formresponse,
                }
            }).then(json => {
                if (silent) return;
                if (json.status.toLowerCase() === "success") {
                    // form saved
                    //this.$router.replace(`/forms`);
					if(!silent){
                    	this.formSubmitSuccess();
                    }
                } else {
                    // something went wrong
					if(!silent){
                    	this.formSubmitFailed();
                    }
                }
            }).catch(error => {
                this.$log.error.call(this, error);
				if(!silent){
                	this.formSubmitFailed();
                }
            }).finally(() => {
                this.$store.commit("hideBlockingSpinner");
            })
        },
        
		getCandidateInfo() {
        	this.$users.getUserById.call(this, this.formresponse.usersubject_id).then(user => {
        		if(user){
        			this.candidate = user
        		}
			});
			return {}
		},
        userCanCompletePage(page) {
            var viewAs = this.role;
            return !('permission' in page) || page.permission.length === 0 || page.permission.includes(viewAs) || viewAs == 'editall'
        },
        userCanViewPage(page) {
            return !page.hideifcantcomplete || this.userCanCompletePage(page) || (page.showaftersignoff && this.formresponse && this.formresponse.formresponse_signedoff == '1');
        },
        scoreIcon(item){
            if(item.score >= 90) return { icon: 'check-circle-fill', variant: 'success' };
            if(item.score <= 50) return { icon: 'x-circle-fill', variant: 'danger' };
            return { icon: 'exclamation-circle-fill', variant: 'warning'}
        },
		
		formUpdated(){
            if (this.debounceTimerId) clearTimeout(this.debounceTimerId)
			if (this.debounceoff == true){
				this.updateFormProgress()
				this.debounceoff = false
				return;
			}
            this.debounceTimerId = setTimeout(() => {
                this.processFormUpdate()
                this.debounceTimerId = null
            }, this.debounceTime)
		},
		
		processFormUpdate(){
			this.updateFormProgress()
			this.saveFormResponse(true)
		},
		
		updateFormProgress(){

			this.completionStats.total = 0;
			this.completionStats.graded = 0;
		
			//Iterate over the form looking for selects
            if (this.formresponse.formresponse_data) {
                for (let page of this.formresponse.formresponse_data.pages) {
                	if('grid' in page){
                    	for (let row of page.grid) {
                    		for(let col of row){
                    			if('fields' in col){
                    				for(let fieldid in col.fields){
                    					var field = col.fields[fieldid]
                    					if(!('conditional' in field) || !field.conditional){
											if(('type' in field) && (field.type == 'select' || field.type == 'text' || field.type == 'textarea' || field.type == 'date' || field.type == 'html' || field.type == 'grade' || field.type == 'mark')){
												this.completionStats.total ++
												if(('value' in field) && field.value !== null && field.value !== undefined && field.value !== ''){
													this.completionStats.graded ++
												}
											}
                    					}
                    				}
                    			}
                    		}
                    	}
                    }
                }
            }
            
            this.completionStats.percentage = Math.round((this.completionStats.graded / this.completionStats.total) * 100);
		},
		
		reopenOSCEButton(){
			this.debounceoff = true;
			this.formresponse.formresponse_completed = 0;
			this.tryEnableMarking();
		},
		
        
        pauseOSCEButton(){
        	var self = this
        	this.resumeOSCE(function(){
        		self.paused = true;
        	});
        },
        pauseOSCE(callback) {
        	this.$store.commit("showBlockingSpinner");
			this.$cfetch(`${this.$settings.APIBaseURL}/osce/forms/event/${this.formresponse.formresponse_id}`, {
				method: 'post',
				data: {
					'event': 'PAUSE'
				}
			}).then(json => {
				if (json.status == 'SUCCESS') {
					this.$store.commit("hideBlockingSpinner");
					callback()
				} else {
					// something went wrong
					this.$store.commit("hideBlockingSpinner");
				}
			}).catch(error => {
				this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
			});
        },
		
        
        resumeOSCEButton(){
        	var self = this
        	this.resumeOSCE(function(){
        		self.paused = false;
        	});
        },
        resumeOSCE(callback) {
        	this.$store.commit("showBlockingSpinner");
			this.$cfetch(`${this.$settings.APIBaseURL}/osce/forms/event/${this.formresponse.formresponse_id}`, {
				method: 'post',
				data: {
					'event': 'RESUME'
				}
			}).then(json => {
				if (json.status == 'SUCCESS') {
					this.$store.commit("hideBlockingSpinner");
					this.tryEnableMarking();
					callback()
				} else {
					// something went wrong
					this.$store.commit("hideBlockingSpinner");
				}
			}).catch(error => {
				this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
			});
        },
    
		completedButton(){
			var self = this;
			this.$store.commit("openDialog", {
				cancelBtn: true,
				title: this.$t("mark-this-osce-complete-question"),
				content: this.$t("the-osce-will-be-completed"),
				confirmCallBack: function () {
					self.debounceoff = true;
					self.formresponse.formresponse_completed = 1
					self.formresponse.formresponse_signedoff = 1
					self.formresponse.formresponse_abandoned = 0
					self.saveFormResponse()
				},
			});
		},
    
		withdrawButton(){
			var self = this;
			this.$store.commit("openDialog", {
				cancelBtn: true,
				title: this.$t("withdraw-osce-question"),
				content: this.$t("the-osce-will-be-withdrawn"),
				confirmCallBack: function () {
					self.debounceoff = true;
					self.formresponse.formresponse_completed = 0
					self.formresponse.formresponse_signedoff = 0
					self.formresponse.formresponse_abandoned = 1
					self.formresponse.status = 2 // mark this formresponse as deleted
					self.saveFormResponse()
				},
			});
		},
    
		abortButton(){
			var self = this;
			this.$store.commit("openDialog", {
				cancelBtn: true,
				title: this.$t("abort-osce-question"),
				content: this.$t("the-osce-will-be-aborted"),
				confirmCallBack: function () {
					self.abortButtonSecondWarning()
				},
			});
		},
		abortButtonSecondWarning(){
			var self = this;
			this.$store.commit("closeDialog");	
			this.$nextTick(() => {
				this.$store.commit("openDialog", {
					cancelBtn: true,
					title: this.$t("abort-osce-question"),
					content: this.$t("osce-abort-final-reminder"),
					confirmCallBack: function () {
						self.debounceoff = true;
						self.formresponse.formresponse_completed = 1
						self.formresponse.formresponse_signedoff = 0
						self.formresponse.formresponse_abandoned = 1
						self.saveFormResponse()
					},
				});
			});
		},
	
		async autoSave() {
			/*
			this.isSaving = true;
			this.showSaveNotification = true;
			
			try {
			// Simulate API call
			await this.$api.saveScores({
			  stationId: this.currentStation.id,
			  candidateId: this.currentCandidate.id,
			  scores: this.currentScores,
			  examiner: this.examinerName
			});
			
			// Also save to localStorage as backup
			const key = `scores_${this.currentStation.id}_${this.currentCandidate.id}`;
			localStorage.setItem(key, JSON.stringify(this.currentScores));
			
			// Hide notification after delay
			setTimeout(() => {
			  this.showSaveNotification = false;
			}, 3000);
			
			} catch (error) {
			console.error('Auto-save failed:', error);
			this.$emit('save-error', error);
			} finally {
			this.isSaving = false;
			}
			*/
		}
    }

};
</script>

<style scoped>
.osce-sidebar {
	position: sticky;
	top: 0;
	padding-top: 10px;
	align-self: flex-start;
	max-height: 100vh;
	overflow-y: auto;
}
.osce-sidebar-panel .card-body {
	max-height: calc(100vh - 150px);
	overflow-y: auto;
}
.question-nav-list li {
	margin-bottom: 0.5rem;
}
</style>